/* eslint-disable array-callback-return */
import React, { useState, useRef } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import { NavLink } from "react-router-dom";


import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Avatar,
  Paper,
  Typography,
  FormControl,
  Box,
  Grid,
  Autocomplete,
  Breadcrumbs,
  Link,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  IconButton,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import DocumentUpload from "../components/DocumentUpload";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: ${(props) => props.theme.spacing(20)};
    padding-right: ${(props) => props.theme.spacing(20)};
  }
`;
const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

let states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
];

const registerCompany = async (
  formData,
  name,
  company_code,
  email_address,
  address_one,
  address_two,
  pincode,
  state,
  city,
  phone_number,
  landline_number,
  gst_number,
  pan_number,
  bank_details,
  is_irn_allowed,
  irn_username,
  irn_password,
  udyamRegNumber,
  signatureFile,
  setErr,
  setSuccess,
  resetForm,
  setImages,
  images,
  snackRef,
  documents,
  profile,
  setLoader,
  navigate
) => {
  try {
    var br = 0;
    Object.values(images).map((doc, i) => {
      if (!documents[i]) {
        setErr("Document Name field cannot be empty");
        setSuccess(false);
        snackRef.current.click();
        br = 1;
        return;
      }
    });
    if (!br) {
      setLoader(true);
      formData.set("name", name);
      formData.set("company_code", company_code);
      formData.set("email_address", email_address);
      formData.set("address_line_one", address_one);
      formData.set("address_line_two", address_two);
      formData.set("pincode", pincode);
      formData.set("state", state);
      formData.set("city", city);
      formData.set("gst_number", gst_number);
      formData.set("pan_number", pan_number);
      formData.set("bank_details", bank_details);
      formData.set("landline_number", landline_number);
      formData.set("is_irn_allowed", is_irn_allowed);
      formData.set("irn_username", irn_username);
      formData.set("irn_password", irn_password);
      formData.set("udyam_registration_number", udyamRegNumber);
      if (signatureFile) {
        formData.set("company_sign", signatureFile);
      }

      if (phone_number[0] !== "+") {
        let numberWithCode = `+91${phone_number}`;
        formData.set("phone_number", numberWithCode);
      } else {
        formData.set("phone_number", phone_number);
      }
      if (profile) {
        formData.set("profile_picture", profile);
      }
      Object.values(images).map((image, i) => {
        formData.set(`document_${i + 1}_file`, image);
      });
      Object.values(documents).map((doc, i) => {
        formData.set(`document_${i + 1}_name`, doc);
      });
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
          "Content-Type": "multipart/data-form",
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userData.type}/ap_company`,
        formData,
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        resetForm({ values: "" });
        snackRef.current.click();
        setImages({});
        navigate("/dashboard/company/ap-companies", {
          state: { success: true, message: "AP Company Registered" },
        });
      }
    }
  } catch (e) {
    setLoader(false);
    setErr(e.response.data.error);
    snackRef.current.click();
    console.log(e.response.data.error);
  }
};

function SignUp() {
  const [images, setImages] = useState("");
  const [documents, setDocuments] = useState("");
  const formData = new FormData();
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [err, setErr] = useState("");
  const snackRef = useRef(null);
  const navigate = useNavigate();
  const [udyamRegNumber, setUdyamRegNumber] = useState("");
  const [signatureFile, setSignatureFile] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState("");

  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };
  const [profile, setProfile] = useState();

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const [loader, setLoader] = useState(false);
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  return (
    <Formik
      initialValues={{
        email_address: "",
        name: "",
        company_code: "",
        phone_number: "",
        landline_number: "",
        address_one: "",
        address_two: "",
        pincode: "",
        state: "",
        city: "",
        gst_number: "",
        pan_number: "",
        bank_details: "",
        submit: false,
        is_irn_allowed: false,
        irn_username: "",
        irn_password: "",
      }}
      validationSchema={Yup.object().shape({
        email_address: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        name: Yup.string().max(255).required("name is required"),
        company_code: Yup.string()
          .required("Comapny Code is required")
          .length(2, "Company Code should have 2 characters only"),
        address_one: Yup.string()
          .max(1000)
          .required("Address Line 1 is required"),
        address_two: Yup.string()
          .max(1000)
          .required("Address Line 2 is required"),
        pincode: Yup.string()
          .required("Pincode is required")
          .length(6, "Pincode should have 6 digits"),
        state: Yup.string().required("State is Required"),
        city: Yup.string().required("City is required"),
        gst_number: Yup.string()
          .length(15, "Should have 15 character")
          .required("GST number is required"),
        pan_number: Yup.string()
          .required("PAN Number is Required")
          .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number"),
        phone_number: Yup.string()
          .required("Phone Number is required")
          .matches(/^(((\+){1}91){1})?[6-9]{1}[0-9]{9}$/, {
            message: "Invalid Indian number",
            excludeEmptyString: false,
          }),
        bank_details: Yup.string().required("Bank Details are required"),
        is_irn_allowed: Yup.boolean(),
        irn_username: Yup.string().when('is_irn_allowed', {
          is: true,
          then: Yup.string().trim().min(1, "Enter Valid Username")
            .required('IRN Username is required')
        }),
        irn_password: Yup.string().when('is_irn_allowed', {
          is: true,
          then: Yup.string().trim().min(1, "Enter Valid Password")
            .required('IRN Password is required')
        })
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting, resetForm }
      ) => {
        try {
          registerCompany(
            formData,
            values.name,
            values.company_code,
            values.email_address,
            values.address_one,
            values.address_two,
            values.pincode,
            values.state,
            values.city,
            values.phone_number,
            values.landline_number,
            values.gst_number,
            values.pan_number,
            values.bank_details,
            values.is_irn_allowed,
            values.irn_username,
            values.irn_password,
            udyamRegNumber,
            signatureFile,
            setErr,
            setSuccess,
            resetForm,
            setImages,
            images,
            snackRef,
            documents,
            profile,
            setLoader,
            navigate
          );
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Button
            ref={snackRef}
            style={{ display: "none" }}
            onClick={handleClick({ vertical: "top", horizontal: "center" })}
          >
            Click
          </Button>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            onClose={handleClose}
            key={vertical + horizontal}
          >
            {err ? (
              <Alert mt={2} mb={4} severity="error">
                {err}
              </Alert>
            ) : success ? (
              <Alert mt={2} mb={4} severity="success">
                Alpha Plus Company registered successfully
              </Alert>
            ) : null}
          </Snackbar>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          {!loader ? (
            <Paper elevation={3} style={{ padding: "2%" }}>
              <Grid container spacing={5}>
                <Grid item xs={12} md={12} lg={12}>
                  <BigAvatar
                    onClick={onButtonClick}
                    style={{ cursor: "pointer" }}
                    src={profile ? URL.createObjectURL(profile) : ""}
                  />
                  <input
                    type="file"
                    id="file"
                    ref={inputFile}
                    accept=".png, .jpg, .jpeg"
                    onChange={(e) => setProfile(e.target.files[0])}
                    style={{ display: "none" }}
                  />
                  <Typography
                    component="h1"
                    variant="h4"
                    align="center"
                    gutterBottom
                  >
                    Add Profile Picture
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    type="text"
                    name="name"
                    label="name"
                    value={values.name}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    type="text"
                    name="company_code"
                    label="company_code"
                    value={values.company_code}
                    error={Boolean(touched.company_code && errors.company_code)}
                    helperText={touched.company_code && errors.company_code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    type="email"
                    name="email_address"
                    label="Email address"
                    value={values.email_address}
                    error={Boolean(
                      touched.email_address && errors.email_address
                    )}
                    fullWidth
                    helperText={touched.email_address && errors.email_address}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    type="text"
                    name="phone_number"
                    label="Phone Number"
                    value={values.phone_number}
                    error={Boolean(touched.phone_number && errors.phone_number)}
                    fullWidth
                    helperText={touched.phone_number && errors.phone_number}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    type="text"
                    name="landline_number"
                    label="Landline Number"
                    value={values.landline_number}
                    fullWidth
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    type="text"
                    name="gst_number"
                    label="GST Number"
                    value={values.gst_number}
                    error={Boolean(touched.gst_number && errors.gst_number)}
                    fullWidth
                    helperText={touched.gst_number && errors.gst_number}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    type="text"
                    name="pan_number"
                    label="PAN Number"
                    value={values.pan_number}
                    error={Boolean(touched.pan_number && errors.pan_number)}
                    fullWidth
                    helperText={touched.pan_number && errors.pan_number}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    type="text"
                    name="bank_details"
                    label="Bank Details"
                    value={values.bank_details}
                    error={Boolean(touched.bank_details && errors.bank_details)}
                    fullWidth
                    helperText={touched.bank_details && errors.bank_details}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    name="udyam_registration_number"
                    label="Udyam Registration Number"
                    value={udyamRegNumber}
                    onChange={(e) => setUdyamRegNumber(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    name="address_one"
                    error={Boolean(touched.address_one && errors.address_one)}
                    value={values.address_one}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={"Address Line 1"}
                    helperText={touched.address_one && errors.address_one}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    name="address_two"
                    error={Boolean(touched.address_two && errors.address_two)}
                    value={values.address_two}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={"Address Line 2"}
                    helperText={touched.address_two && errors.address_two}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    name="pincode"
                    error={Boolean(touched.pincode && errors.pincode)}
                    value={values.pincode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={"Pincode"}
                    helperText={touched.pincode && errors.pincode}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl
                    fullWidth
                    error={Boolean(touched.state && errors.state)}
                  >
                    <Autocomplete
                      id="combo-box-demo"
                      options={states}
                      value={values.state}
                      onChange={(event, newValue) => {
                        setFieldValue("state", newValue || "");
                      }}
                      onBlur={handleBlur}
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(touched.state && errors.state)}
                          helperText={touched.state && errors.state}
                          label="Select State"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    name="city"
                    error={Boolean(touched.city && errors.city)}
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={"City"}
                    helperText={touched.city && errors.city}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <Button variant="contained" component="label">
                    Upload Company Signature
                    <input
                      type="file"
                      hidden
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          // Validate file type
                          if (!file.type.startsWith('image/')) {
                            setErr('Only image files are allowed for company signature');
                            snackRef.current.click();
                            e.target.value = null; // clear input
                            return;
                          }
                          // Valid file
                          setSignatureFile(file);
                          setSignaturePreview(URL.createObjectURL(file));
                        }
                      }}
                    />
                  </Button>
                  {signaturePreview && (
                    <Box mt={2}>
                      <img src={signaturePreview} alt="Signature Preview" height="80" />
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} lg={3} md={3}>
                  <FormControl
                    fullWidth
                    component="fieldset"
                    variant="standard"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="is_irn_allowed"
                          checked={values.is_irn_allowed}
                          onChange={handleChange}
                        />
                      }
                      label={"Enable IRN"}
                    />
                  </FormControl>
                </Grid>
                {values.is_irn_allowed ? (
                  <>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        fullWidth
                        name="irn_username"
                        error={Boolean(touched.irn_username && errors.irn_username)}
                        value={values.irn_username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={"IRN Username"}
                        helperText={touched.irn_username && errors.irn_username}
                      />
                    </Grid>

                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        fullWidth
                        name="irn_password"
                        type={showPassword ? "text" : "password"}
                        error={Boolean(touched.irn_password && errors.irn_password)}
                        value={values.irn_password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={"IRN Password"}
                        helperText={touched.irn_password && errors.irn_password}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }}
                      />
                    </Grid>
                  </>
                ) : ""}

                <Grid item xs={12} lg={12} md={12}>
                  <DocumentUpload
                    images={images}
                    setImages={setImages}
                    documents={documents}
                    setDocuments={setDocuments}
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                  >
                    Register AP Company
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          ) : (
            <Loading />
          )}
        </form>
      )}
    </Formik>
  );
}

function ApCompany({ auths }) {
  return (
    <React.Fragment>
      {/* <Brand /> */}
      <Helmet title="Alpha Plus" />
      <Grid
        justifyContent="space-between"
        alignItems="center"
        container
        spacing={10}
        mb={4}
      >
        <Grid item>
          <Typography
            variant="h4"
            gutterBottom
            display="inline"
            sx={{ fontWeight: 600 }}
            color="primary"
          >
            REGISTER AP COMPANY
          </Typography>
        </Grid>
        <Grid item>
          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/dashboard/tasks">
              Dashboard
            </Link>
            <Link component={NavLink} to="/dashboard/company/ap-companies">
              AP Companies
            </Link>
            <Typography> Register</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Wrapper>
        {/* <BigAvatar alt="Lucy" src="/static/img/avatars/icon.png" /> */}

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Register AP Company
        </Typography>

        <SignUp />
      </Wrapper>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(ApCompany);
